export default {
  activePeriod: null
};
